var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWishibamLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2.5,
    fill: "#EC0044"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4018_2373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.29758 4.83957C8.29758 5.30177 7.92344 5.67915 7.4652 5.67915C7.00695 5.67915 6.63281 5.30177 6.63281 4.83957C6.63281 4.37737 7.00695 4 7.4652 4C7.92344 4 8.29758 4.37737 8.29758 4.83957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28972 6.38208H6.63281V14.0001H8.28972V6.38208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3679 4.83957C11.3679 5.30177 10.9938 5.67915 10.5355 5.67915C10.0773 5.67915 9.70312 5.30177 9.70312 4.83957C9.70312 4.37737 10.0773 4 10.5355 4C10.9938 4 11.3679 4.37737 11.3679 4.83957Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.36 6.38208H9.70312V14.0001H11.36V6.38208Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4018_2373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.73527,
    height: 10,
    fill: "white",
    transform: "translate(6.63281 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishibamLogo);
export default __webpack_public_path__ + "static/media/wishibam-logo.2da5299e28c23630723a6b99c6898b3a.svg";
export { ForwardRef as ReactComponent };